import { PlanComponent } from './profile/plan/plan.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth-guard.service';
import { GeneralComponent } from './profile/general/general.component';
import { EditSecurityComponent } from './profile/security/edit-security.component';
import { EditNotificationComponent } from './profile/notification/edit-notification.component';

const routes: Routes = [
  {
    path: 'general',
    component: GeneralComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'plan',
    component: PlanComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    children: [
      { 
        path: 'editsecurity', component: EditSecurityComponent,
      },
      {
        path: 'editnotification', component: EditNotificationComponent 
      },
    ],
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }
